import { ObjectId } from '@racemap/sdk/schema/base';
import { RacemapAPIClient } from '@racemap/utilities/api-client';
import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import type { ListSessionsResponse, Sessions } from '@racemap/utilities/types/users';
import useSWR, { type KeyedMutator } from 'swr';

export const apiClient = RacemapAPIClient.fromWindowLocation();

export const useListSessions = ({
  userId,
}: { userId?: ObjectId }): {
  sessions: Sessions | undefined;
  currentSessionId: ObjectId | undefined;
  isLoading: boolean;
  error: Error | null;
  mutate: KeyedMutator<ListSessionsResponse>;
} => {
  const { data, isLoading, error, mutate } = useSWR(
    ['USER_SESSIONS', userId?.toHexString()],
    async ([, userId]) => {
      const res = await apiClient.listSessions({ userId: new ObjectId(userId) });
      return res;
    },
    {
      revalidateIfStale: false,
      refreshInterval: OneMinuteInMillis,
    },
  );

  return {
    sessions: data?.sessions,
    currentSessionId: data?.currentSessionId,
    isLoading,
    error,
    mutate,
  };
};
